<template>
    <transition name="slide">
        <div class="modal fade" tabindex="-1" role="dialog" :class="ondetail ? 'show' : 'show'" :style="ondetail ? 'display: block; padding-left: 0px;' : ''">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content shadow-3">
                    <div class="modal-header">
                        <div class="icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4">
                            <i class="bi bi-box"></i>
                        </div>
                        <div>
                            <h5 class="mb-1">{{ data.type }}{{ data.id }}</h5>
                            <small class="d-block text-xs text-muted">
                                <v-tooltip bottom class="mx-1">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on" class="nowrap" v-if="Array.isArray(data.description)">
                                            {{ data.description[0] }} ...
                                        </div>
                                    </template>
                                    <small><div v-for="(description, key) in  data.description" :key="key">{{ description }}</div></small>
                                </v-tooltip>
                            </small>
                        </div>
                        <div class="ms-auto">
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="vstack gap-3">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group mb-2 d-flex align-items-center">
                                        <small class="input-title" style="width: 140px;">Cliente: </small>
                                        <div class="ml-2" style="width: calc(100% - 140px);">
                                            <label class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;">
                                                <router-link v-if="globalViewOption('UserDetail')" :to="{ name: 'UserDetail', params: { role: data.user.role.name, id: data.user.id }}" class="text-decoration-none">
                                                    {{ data.user ? data.user.name + '-' + `${data.type}${data.id}` : ''}}
                                                    <i class="fa-solid fa-square-arrow-up-right"></i>
                                                </router-link>
                                                <div v-else>
                                                    {{ data.user ? data.user.name + '-' + `${data.type}${data.id}` : ''}}
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group mb-2 d-flex align-items-center">
                                        <small class="input-title" style="width: 140px;">Valor: </small>
                                        <div class="ml-2" style="width: calc(100% - 140px);">
                                            <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="Number(data.value || 0).toFixed(2)">
                                        </div>
                                    </div>
                                    <div class="form-group mb-2 d-flex align-items-center">
                                        <small class="input-title" style="width: 140px;">Remitente: </small>
                                        <div class="ml-2" style="width: calc(100% - 140px);">
                                            <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.shipper">
                                        </div>
                                    </div>
                                    <div class="form-group mb-2 d-flex align-items-center">
                                        <small class="input-title" style="width: 140px;">Embalaje: </small>
                                        <div class="ml-2" style="width: calc(100% - 140px);">
                                            <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.packing ? data.packing.name : ''">
                                        </div>
                                    </div>
                                    <div class="form-group mb-2 d-flex align-items-center">
                                        <small class="input-title" style="width: 140px;">Peso: </small>
                                        <div class="ml-2" style="width: calc(100% - 140px);">
                                            <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="Number(data.weight || 0).toFixed(2)">
                                        </div>
                                    </div>
                                    <div class="form-group mb-2 d-flex align-items-center">
                                        <small class="input-title" style="width: 140px;">Dimensiones: </small>
                                        <div class="ml-2" style="width: calc(100% - 140px);">
                                            <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="`${Number(data.lengthy || 0).toFixed(2)} x ${Number(data.width || 0).toFixed(2)} x ${Number(data.tall || 0).toFixed(2)}`">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group mb-2 d-flex align-items-center">
                                        <small class="input-title" style="width: 140px;">Descripción: </small>
                                        <div class="ml-2" style="width: calc(100% - 140px);">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div v-bind="attrs" v-on="on" v-if="Array.isArray(data.description)">
                                                        <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.description[0]">
                                                    </div>
                                                </template>
                                                <small>
                                                    <div v-for="(description, key) in  data.description" :key="key">{{ description }}</div>
                                                </small>
                                            </v-tooltip>
                                        </div>
                                    </div>
                                    <div class="form-group mb-2 d-flex align-items-center">
                                        <small class="input-title" style="width: 140px;">Tracking: </small>
                                        <div class="ml-2" style="width: calc(100% - 140px);">
                                            <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.tracking">
                                        </div>
                                    </div>
                                    <div class="form-group mb-2 d-flex align-items-center" v-if="data.tax">
                                        <small class="input-title" style="width: 140px;">Impuesto: </small>
                                        <div class="ml-2" style="width: calc(100% - 140px);">
                                            <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="Number((data.tax.value*100) || 0).toFixed(2) + '%'">
                                        </div>
                                    </div>
                                    <div class="form-group mb-2 d-flex align-items-center">
                                        <small class="input-title" style="width: 140px;">Piezas: </small>
                                        <div class="ml-2" style="width: calc(100% - 140px);">
                                            <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.pieces">
                                        </div>
                                    </div>
                                    <div class="form-group mb-2 d-flex align-items-center">
                                        <small class="input-title" style="width: 140px;">Peso Volumétrico: </small>
                                        <div class="ml-2" style="width: calc(100% - 140px);">
                                            <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="Number(data.volumetric_weight || 0).toFixed(2)">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6" v-if="data.awb">
                                    <div class="form-group mb-2 d-flex align-items-center">
                                        <small class="input-title" style="width: 140px;">AWB: </small>
                                        <div class="ml-2" style="width: calc(100% - 140px);">
                                            <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.awb.awb">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6" v-if="data.hawb">
                                    <div class="form-group mb-2 d-flex align-items-center">
                                        <small class="input-title" style="width: 140px;">HAWB: </small>
                                        <div class="ml-2" style="width: calc(100% - 140px);">
                                            <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.hawb.hawb">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group mb-2 d-flex align-items-center">
                                        <small class="input-title" style="width: 140px;">Archivos Adjuntos: </small>
                                        <div class="ml-2" style="width: calc(100% - 140px);">
                                            <div class="py-3"></div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-1 col-md-2 col-sm-3 col-4" v-for="(item, index) in data.files">
                                            <img :src="`${item.path}`" class="img-fluid">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-h btn-dark px-3" @click="$emit('onclose')">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default{
    props: {
        ondetail: {
            type: Boolean,
        },
        data: {
            type: Object
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/pages/packages/modals/Detail.vue